import { createContext, useContext } from 'react';

import type Typo from 'typo-js';

export interface SpellSuggestRequestContext {
  word: string;
  rect: DOMRect;
  blockKey: string;
  start: number;
  end: number;
}

interface SpellSuggestContextValue {
  typo: Typo | null;
  onRequestSuggestions: (request: SpellSuggestRequestContext) => void;
  onLeaveSuggestions: () => void;
}

export const SpellSuggestContext = createContext<SpellSuggestContextValue>({
  typo: null,
  onRequestSuggestions: () => {},
  onLeaveSuggestions: () => {},
});

export const useSpellSuggest = () => useContext(SpellSuggestContext);
